<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="mb-4">
                <h1 class="text-first">
                    {{ $t('Auth.ForgotPassword.RouteName') }}
                </h1>
            </div>
            <form class="shadow rounded p-4" @submit.prevent="forgotPassword">
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" v-model="email" class="border-bottom" id="email" :class="{'text-danger' : errors.email}" required>
                        <label for="email" :class="{'text-danger' : errors.email}">
                            <i class="fa-solid fa-envelope me-1"></i>
                            {{ $t('Auth.ForgotPassword.email') }}
                            <small v-if="errors.email" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.email }}
                            </small>
                        </label>
                    </div>
                </div>
                <button type="submit" class="btn btn-auth btn-auth-third w-100 mb-4">
                    {{ $t('Auth.ForgotPassword.send') }}
                </button>
                <router-link to="/" class="text-second">
                    {{ $t('Auth.ForgotPassword.go_back') }}
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ForgotPassword',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            email: null,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        forgotPassword() {
            this.$http
                .post(`${this.apiPath}/email/send_forgot_password_request`, { email: this.email }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.ForgotPassword.errors.email.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.data) {
                        this.$toast.success(`${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong>`)
                        this.$router.replace('/')
                        return
                    } 
                    switch (res.data) {
                        case 'No Account Found':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.NoAccountFound')
                            this.$toast.error(this.$t('Auth.ForgotPassword.errors.email.NoAccountFound'))
                            break
                        case 'Unconfirmed Email':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail')
                            this.$toast.info(this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail'))
                            break
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>